module.exports = __webpack_public_path__ + "img/c00_buildingscalemailandhidearmor_Normal_ua.6008c55b.webp";